import { Box, Text } from '@chakra-ui/react';

export const CardPreview = () => {
  return (
    <Box>
      <Text>CardPreview - Coming soon</Text>
    </Box>
  );
};
